import { useSearchParams } from 'react-router-dom';

const roleLabels: Record<string, { title: string; description: string }> = {
  caregiver_agency: {
    title: 'Find Caregivers & Home Care Agencies',
    description: 'Browse trusted caregivers for personal care, companionship, medication reminders, and daily support.',
  },
  ot: {
    title: 'Find Occupational Therapists',
    description: 'Connect with OTs specializing in home safety assessments, fall prevention, and adaptive equipment.',
  },
  pt: {
    title: 'Find Physical Therapists',
    description: 'Connect with PTs for mobility training, balance exercises, and strength building at home.',
  },
  care_manager: {
    title: 'Find Care Managers',
    description: 'Connect with geriatric care managers for care coordination, planning, and family mediation.',
  },
  elder_law: {
    title: 'Find Elder Law Attorneys',
    description: 'Connect with attorneys specializing in estate planning, Medicaid, guardianship, and veterans benefits.',
  },
  financial_planner: {
    title: 'Find Financial Planners',
    description: 'Connect with advisors specializing in retirement planning, long-term care insurance, and estate preservation.',
  },
  aging_consultant: {
    title: 'Find Aging Consultants',
    description: 'Connect with geriatric specialists and aging-in-place consultants in your area.',
  },
  home_health: {
    title: 'Find Home Health Services',
    description: 'Browse home health providers and senior service organizations near you.',
  },
};

const defaultHeader = {
  title: 'Find Professionals Near You',
  description: 'Browse trusted professionals for home safety, care coordination, health, legal, and financial support.',
};

export function ProfessionalDirectoryHeader() {
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role') || '';
  const header = roleLabels[role] || defaultHeader;

  return (
    <header className="mb-8 text-center lg:text-left">
      <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
        {header.title}
      </h1>
      <p className="text-muted-foreground text-lg max-w-2xl">
        {header.description}
      </p>
    </header>
  );
}
